import usePrivateAxios from "@/common/api/usePrivateAxios";
import { RequestNewCardValidationSchema } from "@/common/schemas/requestNewCard.schema";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";

interface UseRequestNewCardProps {
  userId?: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useClientUserRequestNewCard = ({ userId, onSuccess, onError }: UseRequestNewCardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientUserRequestNewCard', userId],
    mutationFn: (form: RequestNewCardValidationSchema) => privateAxios.post(`/users/${userId}/request_new_card`, {
      card: {
        request_reason_observation: form.request_observation,
        request_reason_id: form.request_reason?.value,
      }
    }),
    onSuccess,
    onError,
  });
};
